(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[331,147,102,47],[0,0,316,47],[384,98,111,47],[0,98,238,47],[318,0,145,47],[240,98,142,47],[0,49,241,47],[0,196,209,47],[211,196,207,47],[0,147,224,47],[226,147,103,47],[243,49,167,47]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_68 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_67 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_66 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_65 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_64 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_63 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_62 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_61 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_60 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_59 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_58 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_57 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(960,499.996,1,0.9259);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1000), null);


(lib.size_90x90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(45,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_90x90, new cjs.Rectangle(0,0,90,90), null);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,1,1).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#EF3C3F").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(7,30,58,0.498)").beginStroke().moveTo(-67.4,30).lineTo(-67.4,-30).lineTo(67.4,-30).lineTo(67.4,30).closePath();
	this.shape.setTransform(67.4,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo, new cjs.Rectangle(0,0,134.8,60), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#4D67AB").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#EC008C").setStrokeStyle(4,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-2,-2,1924,4), null);


(lib.gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#5BC3BE","#1F4F6E"],[0,1],-680,0,680,0).beginStroke().moveTo(-680,2).lineTo(-680,-2).lineTo(680,-2).lineTo(680,2).closePath();
	this.shape.setTransform(680,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gradient, new cjs.Rectangle(0,-2,1360,4), null);


(lib._double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#666666").setStrokeStyle(2,1,1).moveTo(50,-30).lineTo(-550,-30).moveTo(550,30).lineTo(-250,30);
	this.shape.setTransform(550,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib._double, new cjs.Rectangle(-1,-1,1102,62), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 278;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo, new cjs.Rectangle(-106.5,0,679.7,557.6), null);


(lib.ClipGroup_19 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-7.2,73.8).curveTo(-9.6,71.2,-9.6,67.4).lineTo(-9.6,-67.6).curveTo(-9.6,-71.3,-6.9,-73.8).curveTo(-4,-76.4,0,-76.4).curveTo(4.1,-76.4,6.9,-73.8).curveTo(9.6,-71.3,9.6,-67.6).lineTo(9.6,-17.7).lineTo(5.9,-17.7).lineTo(5.9,-67.4).curveTo(5.8,-69.8,4.2,-71.4).curveTo(2.5,-73,0,-73).curveTo(-2.5,-73,-4.2,-71.4).curveTo(-5.8,-69.8,-5.8,-67.4).lineTo(-5.8,67.4).curveTo(-5.8,69.8,-4.2,71.4).curveTo(-2.5,73,0,73).curveTo(2.5,73,4.2,71.4).curveTo(5.8,69.8,5.9,67.4).lineTo(5.9,-1.5).lineTo(-0.8,-1.5).lineTo(-0.8,-4.9).lineTo(9.6,-4.9).lineTo(9.6,75.5).lineTo(5.9,75.5).lineTo(5.9,71.2).curveTo(4.9,73.5,3,74.9).curveTo(1,76.4,-1.5,76.4).curveTo(-4.9,76.4,-7.2,73.8).closePath();
	mask.setTransform(86,86.025);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-273.5,273.5,355,-355).beginStroke().moveTo(-86,0).lineTo(-0,-86).lineTo(86,0).lineTo(-0,86).closePath();
	this.shape.setTransform(86.025,86.025);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_19, new cjs.Rectangle(76.4,9.6,19.19999999999999,152.9), null);


(lib.ClipGroup_18 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(6,75.5).lineTo(-0.9,4.2).lineTo(-6.6,4.2).lineTo(-6.6,75.5).lineTo(-10.3,75.5).lineTo(-10.3,-75.5).lineTo(-0.8,-75.5).curveTo(3.3,-75.5,6.1,-72.9).curveTo(8.8,-70.3,8.8,-66.4).lineTo(8.8,-4.9).curveTo(8.8,-1.9,6.9,0.5).curveTo(5.1,2.7,2.1,3.6).lineTo(10.3,75.5).closePath().moveTo(-6.6,0.8).lineTo(-0.8,0.8).curveTo(1.8,0.8,3.4,-0.9).curveTo(5.1,-2.5,5.1,-4.9).lineTo(5.1,-66.4).curveTo(5.1,-68.8,3.4,-70.4).curveTo(1.8,-72.1,-0.8,-72.1).lineTo(-6.6,-72.1).closePath();
	mask.setTransform(85.825,85.825);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-286.1,286.1,342.4,-342.4).beginStroke().moveTo(-85.8,0).lineTo(-0,-85.8).lineTo(85.8,0).lineTo(-0,85.8).closePath();
	this.shape.setTransform(85.825,85.825);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_18, new cjs.Rectangle(75.5,10.4,20.700000000000003,150.9), null);


(lib.ClipGroup_17 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(6.5,75.5).lineTo(4.4,36.2).lineTo(-4.6,36.2).lineTo(-6.5,75.5).lineTo(-10.2,75.5).lineTo(-2,-75.5).lineTo(1.8,-75.5).lineTo(10.3,75.5).closePath().moveTo(4.2,32.8).lineTo(-0.1,-55.3).lineTo(-4.4,32.8).lineTo(4.2,32.8).closePath();
	mask.setTransform(85.75,85.725);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-296.8,296.9,331.7,-331.6).beginStroke().moveTo(-85.8,0).lineTo(0,-85.7).lineTo(85.8,0).lineTo(0,85.7).closePath();
	this.shape.setTransform(85.75,85.725);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_17, new cjs.Rectangle(75.5,10.3,20.5,150.89999999999998), null);


(lib.ClipGroup_16 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(6,75.5).lineTo(-6,-48.9).lineTo(-6,75.5).lineTo(-9.8,75.5).lineTo(-9.8,-75.5).lineTo(-6,-75.5).lineTo(6.1,42.5).lineTo(6.1,-75.5).lineTo(9.8,-75.5).lineTo(9.8,75.5).closePath();
	mask.setTransform(85.3,85.275);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-309.4,309.4,319.1,-319.1).beginStroke().moveTo(-85.3,0).lineTo(0,-85.3).lineTo(85.3,0).lineTo(0,85.3).closePath();
	this.shape.setTransform(85.3,85.275);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_16, new cjs.Rectangle(75.5,9.8,19.599999999999994,151), null);


(lib.ClipGroup_15 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-9.6,75.5).lineTo(-9.6,-75.5).lineTo(-0,-75.5).curveTo(4.1,-75.5,6.8,-72.9).curveTo(9.6,-70.3,9.6,-66.4).lineTo(9.6,66.4).curveTo(9.6,70.3,6.8,72.9).curveTo(4.1,75.5,-0,75.5).closePath().moveTo(-5.8,72.1).lineTo(-0,72.1).curveTo(2.5,72.1,4.2,70.5).curveTo(5.8,68.8,5.9,66.4).lineTo(5.9,-66.4).curveTo(5.8,-68.8,4.2,-70.4).curveTo(2.5,-72.1,-0,-72.1).lineTo(-5.8,-72.1).closePath();
	mask.setTransform(85.05,85.075);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-321.7,321.7,306.8,-306.8).beginStroke().moveTo(-85.1,0).lineTo(-0,-85.1).lineTo(85.1,0).lineTo(-0,85.1).closePath();
	this.shape.setTransform(85.075,85.075);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_15, new cjs.Rectangle(75.5,9.6,19.200000000000003,151), null);


(lib.ClipGroup_14 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-3.9,5.3).lineTo(-3.9,-5.3).lineTo(0.2,-5.3).curveTo(1.7,-5.3,2.8,-4.2).curveTo(3.9,-3.2,3.9,-1.7).curveTo(3.9,-0.1,2.8,0.9).curveTo(1.7,2,0.2,2).lineTo(-1.4,2).lineTo(-1.4,5.3).closePath().moveTo(-1.4,-0.3).lineTo(0.2,-0.3).curveTo(0.7,-0.3,1.1,-0.7).curveTo(1.4,-1.1,1.4,-1.7).curveTo(1.4,-2.2,1.1,-2.6).curveTo(0.7,-3,0.2,-3).lineTo(-1.4,-3).closePath();
	mask.setTransform(9.175,9.175);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-493.5,493.6,667.3,-667.2).beginStroke().moveTo(-9.2,0).lineTo(-0,-9.2).lineTo(9.2,0).lineTo(-0,9.2).closePath();
	this.shape.setTransform(9.175,9.175);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_14, new cjs.Rectangle(5.3,3.9,7.8,10.6), null);


(lib.ClipGroup_13 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(2.5,5.3).lineTo(2,3.7).lineTo(-2,3.7).lineTo(-2.5,5.3).lineTo(-5.2,5.3).lineTo(-1.5,-5.3).lineTo(1.6,-5.3).lineTo(5.2,5.3).closePath().moveTo(1.2,1.4).lineTo(0,-2.5).lineTo(-1.2,1.4).lineTo(1.2,1.4).closePath();
	mask.setTransform(10.475,10.475);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-498,498,662.8,-662.8).beginStroke().moveTo(-10.5,0).lineTo(0,-10.5).lineTo(10.5,0).lineTo(0,10.5).closePath();
	this.shape.setTransform(10.475,10.475);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_13, new cjs.Rectangle(5.3,5.2,10.399999999999999,10.600000000000001), null);


(lib.ClipGroup_12 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-4.7,5.3).lineTo(-4.7,-5.3).lineTo(-0.5,-5.3).curveTo(1.7,-5.3,3.2,-3.8).curveTo(4.7,-2.2,4.7,0).curveTo(4.7,2.3,3.2,3.8).curveTo(1.7,5.3,-0.5,5.3).closePath().moveTo(-2.3,3).lineTo(-0.5,3).curveTo(0.8,3,1.6,2.2).curveTo(2.4,1.4,2.4,0).curveTo(2.4,-1.4,1.6,-2.2).curveTo(0.8,-3,-0.5,-3).lineTo(-2.3,-3).closePath();
	mask.setTransform(10.025,10.025);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-503.5,503.5,657.3,-657.3).beginStroke().moveTo(-10,0).lineTo(-0,-10).lineTo(10,0).lineTo(-0,10).closePath();
	this.shape.setTransform(10.025,10.025);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_12, new cjs.Rectangle(5.3,4.7,9.5,10.7), null);


(lib.ClipGroup_11 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(1.5,5.3).lineTo(-0.5,1.8).lineTo(-1.7,1.8).lineTo(-1.7,5.3).lineTo(-4.1,5.3).lineTo(-4.1,-5.3).lineTo(0.1,-5.3).curveTo(1.7,-5.3,2.7,-4.2).curveTo(3.8,-3.2,3.8,-1.7).curveTo(3.8,0.5,1.8,1.4).lineTo(4.1,5.3).closePath().moveTo(-1.7,-0.3).lineTo(0.1,-0.3).curveTo(0.7,-0.3,1,-0.7).curveTo(1.4,-1.1,1.4,-1.7).curveTo(1.4,-2.2,1,-2.6).curveTo(0.7,-3,0.1,-3).lineTo(-1.7,-3).closePath();
	mask.setTransform(9.425,9.375);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-508.7,508.7,652.1,-652.1).beginStroke().moveTo(-9.4,-0).lineTo(-0,-9.4).lineTo(9.4,-0).lineTo(-0,9.4).closePath();
	this.shape.setTransform(9.425,9.4);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_11, new cjs.Rectangle(5.4,4.1,8.1,10.6), null);


(lib.ClipGroup_10 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-3.3,5.3).lineTo(-3.3,-5.3).lineTo(3.2,-5.3).lineTo(3.2,-3).lineTo(-0.9,-3).lineTo(-0.9,-1.2).lineTo(2.9,-1.2).lineTo(2.9,1.1).lineTo(-0.9,1.1).lineTo(-0.9,3).lineTo(3.3,3).lineTo(3.3,5.3).closePath();
	mask.setTransform(8.65,8.625);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-513.2,513.2,647.6,-647.6).beginStroke().moveTo(-8.7,-0).lineTo(-0,-8.7).lineTo(8.6,-0).lineTo(-0,8.6).closePath();
	this.shape.setTransform(8.65,8.65);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_10, new cjs.Rectangle(5.3,3.3,6.7,10.7), null);


(lib.ClipGroup_9 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(2.5,5.3).lineTo(1.9,3.7).lineTo(-2,3.7).lineTo(-2.5,5.3).lineTo(-5.2,5.3).lineTo(-1.6,-5.3).lineTo(1.6,-5.3).lineTo(5.2,5.3).closePath().moveTo(1.3,1.4).lineTo(0,-2.5).lineTo(-1.2,1.4).lineTo(1.3,1.4).closePath();
	mask.setTransform(10.5,10.475);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-505.1,505.2,626.7,-626.6).beginStroke().moveTo(-10.5,0).lineTo(0,-10.5).lineTo(10.5,0).lineTo(0,10.5).closePath();
	this.shape.setTransform(10.475,10.475);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_9, new cjs.Rectangle(5.4,5.2,10.299999999999999,10.600000000000001), null);


(lib.ClipGroup_8 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-4.7,5.3).lineTo(-4.7,-5.3).lineTo(-0.4,-5.3).curveTo(1.7,-5.3,3.2,-3.8).curveTo(4.7,-2.2,4.7,0).curveTo(4.7,2.3,3.2,3.8).curveTo(1.7,5.3,-0.4,5.3).closePath().moveTo(-2.3,3).lineTo(-0.4,3).curveTo(0.8,3,1.6,2.2).curveTo(2.3,1.4,2.4,0).curveTo(2.3,-1.3,1.6,-2.2).curveTo(0.8,-3,-0.4,-3).lineTo(-2.3,-3).closePath();
	mask.setTransform(10.05,10.025);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-525.1,525.2,635.7,-635.6).beginStroke().moveTo(-10,0).lineTo(0,-10).lineTo(10,0).lineTo(0,10).closePath();
	this.shape.setTransform(10.025,10.025);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_8, new cjs.Rectangle(5.4,4.7,9.4,10.7), null);


(lib.ClipGroup_7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-3.3,5.3).lineTo(-3.3,-5.3).lineTo(3.3,-5.3).lineTo(3.3,-3).lineTo(-0.9,-3).lineTo(-0.9,-1.2).lineTo(2.9,-1.2).lineTo(2.9,1.1).lineTo(-0.9,1.1).lineTo(-0.9,3).lineTo(3.3,3).lineTo(3.3,5.3).closePath();
	mask.setTransform(8.625,8.625);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-530,530,630.8,-630.8).beginStroke().moveTo(-8.7,-0).lineTo(-0,-8.7).lineTo(8.6,-0).lineTo(-0,8.6).closePath();
	this.shape.setTransform(8.65,8.65);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_7, new cjs.Rectangle(5.3,3.3,6.7,10.7), null);


(lib.ClipGroup_6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-3.1,5.3).lineTo(-3.1,-5.3).lineTo(-0.7,-5.3).lineTo(-0.7,3).lineTo(3.1,3).lineTo(3.1,5.3).closePath();
	mask.setTransform(8.425,8.425);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-519.7,519.7,612.1,-612.1).beginStroke().moveTo(-8.4,0).lineTo(-0,-8.4).lineTo(8.4,0).lineTo(-0,8.4).closePath();
	this.shape.setTransform(8.425,8.425);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_6, new cjs.Rectangle(5.3,3.1,6.3,10.700000000000001), null);


(lib.ClipGroup_5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-1.2,5.3).lineTo(-1.2,-5.3).lineTo(1.2,-5.3).lineTo(1.2,5.3).closePath();
	mask.setTransform(6.55,6.525);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-536.9,537,623.9,-623.8).beginStroke().moveTo(-6.5,0).lineTo(0,-6.5).lineTo(6.5,0).lineTo(0,6.5).closePath();
	this.shape.setTransform(6.525,6.525);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_5, new cjs.Rectangle(5.4,1.2,2.3999999999999995,10.700000000000001), null);


(lib.ClipGroup_4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(2.4,5.3).lineTo(-1.7,-0.4).lineTo(-1.7,5.3).lineTo(-4.2,5.3).lineTo(-4.2,-5.3).lineTo(-2.3,-5.3).lineTo(1.7,0.5).lineTo(1.7,-5.3).lineTo(4.2,-5.3).lineTo(4.2,5.3).closePath();
	mask.setTransform(9.475,9.475);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-540.7,540.8,620.1,-620).beginStroke().moveTo(-9.5,0).lineTo(-0,-9.5).lineTo(9.5,0).lineTo(-0,9.5).closePath();
	this.shape.setTransform(9.475,9.475);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_4, new cjs.Rectangle(5.3,4.2,8.399999999999999,10.600000000000001), null);


(lib.ClipGroup_3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-3.9,3.9).curveTo(-5.5,2.3,-5.5,0).curveTo(-5.5,-2.3,-3.9,-3.9).curveTo(-2.3,-5.5,-0,-5.5).curveTo(2.3,-5.5,3.9,-3.9).curveTo(5.5,-2.3,5.5,0).curveTo(5.5,2.3,3.9,3.9).curveTo(2.3,5.5,-0,5.5).curveTo(-2.3,5.5,-3.9,3.9).closePath().moveTo(-2.2,-2.3).curveTo(-3.1,-1.4,-3.1,0).curveTo(-3.1,1.4,-2.2,2.3).curveTo(-1.3,3.2,-0,3.2).curveTo(1.3,3.2,2.2,2.3).curveTo(3.1,1.4,3.1,0).curveTo(3.1,-1.4,2.2,-2.3).curveTo(1.3,-3.1,-0,-3.1).curveTo(-1.3,-3.1,-2.2,-2.3).closePath();
	mask.setTransform(11.075,11.025);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-546.4,546.4,614.4,-614.4).beginStroke().moveTo(-11.1,0).lineTo(0,-11.1).lineTo(11.1,0).lineTo(0,11.1).closePath();
	this.shape.setTransform(11.05,11.05);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_3, new cjs.Rectangle(5.6,5.5,11.000000000000002,11.100000000000001), null);


(lib.ClipGroup_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-2.7,11.8).lineTo(-2.7,-6.6).lineTo(-8.8,-6.6).lineTo(-8.8,-11.8).lineTo(8.8,-11.8).lineTo(8.8,-6.6).lineTo(2.7,-6.6).lineTo(2.7,11.8).closePath();
	mask.setTransform(20.575,20.6);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-402.6,402.6,486.9,-486.9).beginStroke().moveTo(-20.6,0).lineTo(0,-20.6).lineTo(20.6,0).lineTo(0,20.6).closePath();
	this.shape.setTransform(20.575,20.6);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_2, new cjs.Rectangle(11.8,8.8,17.599999999999998,23.599999999999998), null);


(lib.ClipGroup_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(3.7,11.8).lineTo(3.7,2.4).lineTo(-3.7,2.4).lineTo(-3.7,11.8).lineTo(-9.1,11.8).lineTo(-9.1,-11.8).lineTo(-3.7,-11.8).lineTo(-3.7,-2.7).lineTo(3.7,-2.7).lineTo(3.7,-11.8).lineTo(9.1,-11.8).lineTo(9.1,11.8).closePath();
	mask.setTransform(20.925,20.9);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-412.7,412.7,476.8,-476.8).beginStroke().moveTo(-20.9,-0).lineTo(0,-20.9).lineTo(20.9,-0).lineTo(0,20.9).closePath();
	this.shape.setTransform(20.925,20.9);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_1, new cjs.Rectangle(11.8,9.1,18.3,23.6), null);


(lib.ClipGroup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-7.4,11.8).lineTo(-7.4,-11.8).lineTo(7.2,-11.8).lineTo(7.2,-6.6).lineTo(-2,-6.6).lineTo(-2,-2.7).lineTo(6.4,-2.7).lineTo(6.4,2.4).lineTo(-2,2.4).lineTo(-2,6.6).lineTo(7.4,6.6).lineTo(7.4,11.8).closePath();
	mask.setTransform(19.275,19.25);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#282F42","#2F3954","#455A91","#4F6AB0","#4D67AA","#475E99","#3F5080","#344062","#292F42","#282F42","#282F42"],[0,0.102,0.318,0.404,0.478,0.584,0.706,0.839,0.98,0.984,1],-423,423,466.5,-466.5).beginStroke().moveTo(-19.2,0).lineTo(0,-19.2).lineTo(19.3,0).lineTo(0,19.3).closePath();
	this.shape.setTransform(19.25,19.25);

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup, new cjs.Rectangle(11.9,7.5,14.799999999999999,23.6), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(1215.7,13);
	this.instance.visible = false;

	this.instance_1 = new lib.vertical();
	this.instance_1.setTransform(1071.5,13);
	this.instance_1.visible = false;

	this.instance_2 = new lib.vertical();
	this.instance_2.setTransform(833.4,13);
	this.instance_2.visible = false;

	this.instance_3 = new lib.vertical();
	this.instance_3.setTransform(634.5,13);
	this.instance_3.visible = false;

	this.instance_4 = new lib.vertical();
	this.instance_4.setTransform(1410.4,13);
	this.instance_4.visible = false;

	this.instance_5 = new lib.vertical();
	this.instance_5.setTransform(450.8,13);
	this.instance_5.visible = false;

	this.instance_6 = new lib.vertical();
	this.instance_6.setTransform(273.8,13);
	this.instance_6.visible = false;

	this.instance_7 = new lib.vertical();
	this.instance_7.setTransform(88,13);
	this.instance_7.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// square
	this.instance_8 = new lib.square();
	this.instance_8.setTransform(1215.7,13);
	this.instance_8.visible = false;

	this.instance_9 = new lib.square();
	this.instance_9.setTransform(1071.5,13);
	this.instance_9.visible = false;

	this.instance_10 = new lib.square();
	this.instance_10.setTransform(833.4,13);
	this.instance_10.visible = false;

	this.instance_11 = new lib.square();
	this.instance_11.setTransform(1410.4,13);
	this.instance_11.visible = false;

	this.instance_12 = new lib.square();
	this.instance_12.setTransform(634.5,13);
	this.instance_12.visible = false;

	this.instance_13 = new lib.square();
	this.instance_13.setTransform(450.8,13);
	this.instance_13.visible = false;

	this.instance_14 = new lib.square();
	this.instance_14.setTransform(273.8,13);
	this.instance_14.visible = false;

	this.instance_15 = new lib.square();
	this.instance_15.setTransform(88,13);
	this.instance_15.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8}]}).wait(1));

	// ball
	this.instance_16 = new lib.ball();
	this.instance_16.setTransform(1474.1,15.55);

	this.instance_17 = new lib.CachedBmp_57();
	this.instance_17.setTransform(1492.3,3.85,0.5,0.5);

	this.instance_18 = new lib.ball();
	this.instance_18.setTransform(1386.9,15.55);

	this.instance_19 = new lib.ball();
	this.instance_19.setTransform(1289.5,15.55);

	this.instance_20 = new lib.ball();
	this.instance_20.setTransform(1176.1,15.55);

	this.instance_21 = new lib.ball();
	this.instance_21.setTransform(1061.8,15.55);

	this.instance_22 = new lib.ball();
	this.instance_22.setTransform(909.3,15.55);

	this.instance_23 = new lib.ball();
	this.instance_23.setTransform(759.5,15.55);

	this.instance_24 = new lib.ball();
	this.instance_24.setTransform(607,15.55);

	this.instance_25 = new lib.ball();
	this.instance_25.setTransform(402.1,15.55);

	this.instance_26 = new lib.ball();
	this.instance_26.setTransform(236.3,15.55);

	this.instance_27 = new lib.ball();
	this.instance_27.setTransform(73.2,15.55);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27},{t:this.instance_26},{t:this.instance_25},{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16}]}).wait(1));

	// title
	this.instance_28 = new lib.CachedBmp_68();
	this.instance_28.setTransform(1405.1,3.85,0.5,0.5);

	this.instance_29 = new lib.CachedBmp_67();
	this.instance_29.setTransform(425.65,3.85,0.5,0.5);

	this.instance_30 = new lib.CachedBmp_66();
	this.instance_30.setTransform(1310.45,3.85,0.5,0.5);

	this.instance_31 = new lib.CachedBmp_65();
	this.instance_31.setTransform(95.25,3.85,0.5,0.5);

	this.instance_32 = new lib.CachedBmp_64();
	this.instance_32.setTransform(1082.7,3.85,0.5,0.5);

	this.instance_33 = new lib.CachedBmp_63();
	this.instance_33.setTransform(1197.4,3.85,0.5,0.5);

	this.instance_34 = new lib.CachedBmp_62();
	this.instance_34.setTransform(258.85,3.85,0.5,0.5);

	this.instance_35 = new lib.CachedBmp_61();
	this.instance_35.setTransform(933.25,3.85,0.5,0.5);

	this.instance_36 = new lib.CachedBmp_60();
	this.instance_36.setTransform(782.55,3.85,0.5,0.5);

	this.instance_37 = new lib.CachedBmp_59();
	this.instance_37.setTransform(627.15,3.85,0.5,0.5);

	this.instance_38 = new lib.CachedBmp_58();
	this.instance_38.setTransform(2.8,3.85,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_38},{t:this.instance_37},{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(2.8,3.9,1573,23.5), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(1).to({y:0},9).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,45.2,52.7);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line_gradient
	this.instance_1 = new lib.gradient();
	this.instance_1.setTransform(560,0);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// line_double
	this.instance_2 = new lib._double();
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#071E3A").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-2,-2,1924,82), null);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// line_mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_2 = new cjs.Graphics().moveTo(18,40).lineTo(18,-40).lineTo(125,-40).lineTo(125,40).closePath().moveTo(-125,40).lineTo(-125,-40).lineTo(-18,-40).lineTo(-18,40).closePath();

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:null,x:0,y:0}).wait(2).to({graphics:mask_graphics_2,x:125,y:40}).wait(3));

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginLinearGradientStroke(["rgba(68,99,169,0)","#4463A9","rgba(68,99,169,0)"],[0,0.471,1],-125.6,0,125.5,0).setStrokeStyle(1,1,1).moveTo(-125,0).lineTo(125,0);
	this.shape.setTransform(125,40);
	this.shape._off = true;

	var maskedShapeInstanceList = [this.shape];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2).to({_off:false},0).wait(3));

	// background
	this.instance = new lib.ClipGroup();
	this.instance.setTransform(124,26.7,0.1447,0.1447,0,0,0,20.8,20.4);

	this.instance_1 = new lib.ClipGroup_1();
	this.instance_1.setTransform(121,26.7,0.1447,0.1447,0,0,0,22.4,21.8);

	this.instance_2 = new lib.ClipGroup_2();
	this.instance_2.setTransform(118.05,26.7,0.1447,0.1447,0,0,0,21.8,21.4);

	this.instance_3 = new lib.ClipGroup_3();
	this.instance_3.setTransform(132.65,54.15,0.1447,0.1447,0,0,0,12.5,11.8);

	this.instance_4 = new lib.ClipGroup_4();
	this.instance_4.setTransform(131,54.15,0.1447,0.1447,0,0,0,11.1,10.3);

	this.instance_5 = new lib.ClipGroup_5();
	this.instance_5.setTransform(129.9,54.15,0.1447,0.1447,0,0,0,8,7.2);

	this.instance_6 = new lib.ClipGroup_6();
	this.instance_6.setTransform(129.1,54.15,0.1447,0.1447,0,0,0,10,9.3);

	this.instance_7 = new lib.ClipGroup_7();
	this.instance_7.setTransform(127.9,54.15,0.1447,0.1447,0,0,0,10,9.3);

	this.instance_8 = new lib.ClipGroup_8();
	this.instance_8.setTransform(126.5,54.15,0.1447,0.1447,0,0,0,11.8,10.7);

	this.instance_9 = new lib.ClipGroup_9();
	this.instance_9.setTransform(124.9,54.15,0.1447,0.1447,0,0,0,12.1,11.4);

	this.instance_10 = new lib.ClipGroup_10();
	this.instance_10.setTransform(123,54.15,0.1447,0.1447,0,0,0,10,9.3);

	this.instance_11 = new lib.ClipGroup_11();
	this.instance_11.setTransform(121.75,54.15,0.1447,0.1447,0,0,0,11.1,10.3);

	this.instance_12 = new lib.ClipGroup_12();
	this.instance_12.setTransform(120.2,54.15,0.1447,0.1447,0,0,0,11.4,10.7);

	this.instance_13 = new lib.ClipGroup_13();
	this.instance_13.setTransform(118.6,54.15,0.1447,0.1447,0,0,0,11.8,11.4);

	this.instance_14 = new lib.ClipGroup_14();
	this.instance_14.setTransform(117.35,54.15,0.1447,0.1447,0,0,0,10.7,10);

	this.instance_15 = new lib.ClipGroup_15();
	this.instance_15.setTransform(132.1,40.9,0.1447,0.1447,0,0,0,86.8,86);

	this.instance_16 = new lib.ClipGroup_16();
	this.instance_16.setTransform(128.5,40.9,0.1447,0.1447,0,0,0,86.8,86);

	this.instance_17 = new lib.ClipGroup_17();
	this.instance_17.setTransform(124.9,40.9,0.1447,0.1447,0,0,0,87.4,86.8);

	this.instance_18 = new lib.ClipGroup_18();
	this.instance_18.setTransform(121.75,40.9,0.1447,0.1447,0,0,0,87.1,86.8);

	this.instance_19 = new lib.ClipGroup_19();
	this.instance_19.setTransform(118.1,40.9,0.1447,0.1447,0,0,0,87.4,87.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_19,p:{regX:87.4,regY:87.1,scaleX:0.1447,scaleY:0.1447,x:118.1,y:40.9}},{t:this.instance_18,p:{regX:87.1,regY:86.8,scaleX:0.1447,scaleY:0.1447,x:121.75,y:40.9}},{t:this.instance_17,p:{regX:87.4,regY:86.8,scaleX:0.1447,scaleY:0.1447,x:124.9,y:40.9}},{t:this.instance_16,p:{regX:86.8,scaleX:0.1447,scaleY:0.1447,x:128.5,y:40.9,regY:86}},{t:this.instance_15,p:{regX:86.8,regY:86,scaleX:0.1447,scaleY:0.1447,x:132.1,y:40.9}},{t:this.instance_14,p:{regX:10.7,regY:10,scaleX:0.1447,scaleY:0.1447,x:117.35,y:54.15}},{t:this.instance_13,p:{regX:11.8,regY:11.4,scaleX:0.1447,scaleY:0.1447,x:118.6,y:54.15}},{t:this.instance_12,p:{regX:11.4,regY:10.7,scaleX:0.1447,scaleY:0.1447,x:120.2,y:54.15}},{t:this.instance_11,p:{regX:11.1,regY:10.3,scaleX:0.1447,scaleY:0.1447,x:121.75,y:54.15}},{t:this.instance_10,p:{regX:10,regY:9.3,scaleX:0.1447,scaleY:0.1447,x:123,y:54.15}},{t:this.instance_9,p:{regX:12.1,regY:11.4,scaleX:0.1447,scaleY:0.1447,x:124.9,y:54.15}},{t:this.instance_8,p:{regX:11.8,regY:10.7,scaleX:0.1447,scaleY:0.1447,x:126.5,y:54.15}},{t:this.instance_7,p:{regX:10,regY:9.3,scaleX:0.1447,scaleY:0.1447,x:127.9,y:54.15}},{t:this.instance_6,p:{regX:10,regY:9.3,scaleX:0.1447,scaleY:0.1447,x:129.1,y:54.15}},{t:this.instance_5,p:{regX:8,regY:7.2,scaleX:0.1447,scaleY:0.1447,x:129.9,y:54.15}},{t:this.instance_4,p:{regX:11.1,regY:10.3,scaleX:0.1447,scaleY:0.1447,x:131,y:54.15}},{t:this.instance_3,p:{regY:11.8,scaleX:0.1447,scaleY:0.1447,x:132.65,y:54.15,regX:12.5}},{t:this.instance_2,p:{regY:21.4,scaleX:0.1447,scaleY:0.1447,x:118.05,y:26.7,regX:21.8}},{t:this.instance_1,p:{regX:22.4,regY:21.8,scaleX:0.1447,scaleY:0.1447,x:121,y:26.7}},{t:this.instance,p:{regX:20.8,regY:20.4,scaleX:0.1447,scaleY:0.1447,x:124,y:26.7}}]},2).to({state:[{t:this.instance_19,p:{regX:87,regY:86.8,scaleX:0.1931,scaleY:0.1931,x:115.75,y:41.2}},{t:this.instance_18,p:{regX:87,regY:86.5,scaleX:0.1931,scaleY:0.1931,x:120.65,y:41.2}},{t:this.instance_17,p:{regX:87.2,regY:86.5,scaleX:0.1931,scaleY:0.1931,x:124.85,y:41.2}},{t:this.instance_16,p:{regX:86.5,scaleX:0.1931,scaleY:0.1931,x:129.65,y:41.2,regY:86}},{t:this.instance_15,p:{regX:86.5,regY:85.7,scaleX:0.1931,scaleY:0.1931,x:134.45,y:41.2}},{t:this.instance_14,p:{regX:10.6,regY:9.6,scaleX:0.1931,scaleY:0.1931,x:114.75,y:58.85}},{t:this.instance_13,p:{regX:11.7,regY:11.2,scaleX:0.1931,scaleY:0.1931,x:116.45,y:58.85}},{t:this.instance_12,p:{regX:11.2,regY:10.3,scaleX:0.1931,scaleY:0.1931,x:118.55,y:58.85}},{t:this.instance_11,p:{regX:10.6,regY:9.8,scaleX:0.1931,scaleY:0.1931,x:120.6,y:58.85}},{t:this.instance_10,p:{regX:9.8,regY:8.8,scaleX:0.1931,scaleY:0.1931,x:122.3,y:58.85}},{t:this.instance_9,p:{regX:11.9,regY:11.2,scaleX:0.1931,scaleY:0.1931,x:124.85,y:58.85}},{t:this.instance_8,p:{regX:11.4,regY:10.3,scaleX:0.1931,scaleY:0.1931,x:126.95,y:58.85}},{t:this.instance_7,p:{regX:10.1,regY:8.8,scaleX:0.1931,scaleY:0.1931,x:128.85,y:58.85}},{t:this.instance_6,p:{regX:9.8,regY:8.8,scaleX:0.1931,scaleY:0.1931,x:130.45,y:58.85}},{t:this.instance_5,p:{regX:7.8,regY:6.8,scaleX:0.1931,scaleY:0.1931,x:131.5,y:58.85}},{t:this.instance_4,p:{regX:10.9,regY:9.8,scaleX:0.1931,scaleY:0.1931,x:132.95,y:58.85}},{t:this.instance_3,p:{regY:11.7,scaleX:0.1931,scaleY:0.1931,x:135.15,y:58.85,regX:12.5}},{t:this.instance_2,p:{regY:20.7,scaleX:0.1931,scaleY:0.1931,x:115.7,y:22.15,regX:21.8}},{t:this.instance_1,p:{regX:22,regY:20.9,scaleX:0.1931,scaleY:0.1931,x:119.6,y:22.15}},{t:this.instance,p:{regX:20.4,regY:19.4,scaleX:0.1931,scaleY:0.1931,x:123.6,y:22.15}}]},1).to({state:[{t:this.instance_19,p:{regX:86,regY:85.9,scaleX:0.2895,scaleY:0.2895,x:111.05,y:41.8}},{t:this.instance_18,p:{regX:85.9,regY:85.5,scaleX:0.2895,scaleY:0.2895,x:118.35,y:41.8}},{t:this.instance_17,p:{regX:85.9,regY:85.5,scaleX:0.2895,scaleY:0.2895,x:124.6,y:41.8}},{t:this.instance_16,p:{regX:85.3,scaleX:0.2895,scaleY:0.2895,x:131.85,y:41.8,regY:85}},{t:this.instance_15,p:{regX:85.2,regY:84.8,scaleX:0.2895,scaleY:0.2895,x:139,y:41.8}},{t:this.instance_14,p:{regX:9.3,regY:9,scaleX:0.2895,scaleY:0.2895,x:109.5,y:68.3}},{t:this.instance_13,p:{regX:10.6,regY:10.2,scaleX:0.2895,scaleY:0.2895,x:112.05,y:68.3}},{t:this.instance_12,p:{regX:10.2,regY:9.7,scaleX:0.2895,scaleY:0.2895,x:115.25,y:68.3}},{t:this.instance_11,p:{regX:9.5,regY:9.2,scaleX:0.2895,scaleY:0.2895,x:118.3,y:68.3}},{t:this.instance_10,p:{regX:8.7,regY:8.3,scaleX:0.2895,scaleY:0.2895,x:120.85,y:68.3}},{t:this.instance_9,p:{regX:10.6,regY:10.2,scaleX:0.2895,scaleY:0.2895,x:124.6,y:68.3}},{t:this.instance_8,p:{regX:10.2,regY:9.7,scaleX:0.2895,scaleY:0.2895,x:127.8,y:68.3}},{t:this.instance_7,p:{regX:8.7,regY:8.3,scaleX:0.2895,scaleY:0.2895,x:130.6,y:68.3}},{t:this.instance_6,p:{regX:8.4,regY:8.1,scaleX:0.2895,scaleY:0.2895,x:133,y:68.3}},{t:this.instance_5,p:{regX:6.5,regY:6.2,scaleX:0.2895,scaleY:0.2895,x:134.6,y:68.3}},{t:this.instance_4,p:{regX:9.5,regY:9.2,scaleX:0.2895,scaleY:0.2895,x:136.8,y:68.3}},{t:this.instance_3,p:{regY:10.7,scaleX:0.2895,scaleY:0.2895,x:140.1,y:68.3,regX:11.1}},{t:this.instance_2,p:{regY:20.2,scaleX:0.2895,scaleY:0.2895,x:110.95,y:13.35,regX:20.6}},{t:this.instance_1,p:{regX:20.9,regY:20.6,scaleX:0.2895,scaleY:0.2895,x:116.8,y:13.35}},{t:this.instance,p:{regX:19.4,regY:19,scaleX:0.2895,scaleY:0.2895,x:122.8,y:13.35}}]},1).wait(1));

	// size
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-110,40).lineTo(-110,-40).lineTo(110,-40).lineTo(110,40).closePath();
	this.shape_1.setTransform(125.0005,40,1.1364,1);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,250,80);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8,frame09:9,frame10:10,frame11:11,frame12:12,frame13:13};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(14));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#162239").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(960,540);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape_1.setTransform(960,540);
	this.shape_1._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},2).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_1}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(4).to({_off:false},0).wait(1).to({_off:true},1).wait(1).to({_off:false},0).to({_off:true},1).wait(1).to({_off:false},0).wait(5));

	// size
	this.instance = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(14));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":30,"end":59};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart('index', 'before');
	}
	this.frame_29 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete('index', 'before');
	}
	this.frame_59 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd('index', 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(29).call(this.frame_29).wait(30).call(this.frame_59).wait(1));

	// logo
	this.instance = new lib.logo();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},28).wait(1).to({alpha:0},29).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(29).to({_off:false},0).to({_off:true},2).wait(29));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(29).to({_off:false},0).to({_off:true},2).wait(29));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(60));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1000);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,"frame09":9,"frame10":10,"frame11":11,"frame12":12,"frame13":13};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(14));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(35.65,0);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:163.9},0).wait(1).to({x:328.35},0).wait(1).to({x:512.95},0).wait(1).to({x:688.8},0).wait(1).to({x:844.35},0).wait(1).to({x:990.1},0).wait(1).to({x:1124.75},0).wait(1).to({x:1239.5},0).wait(1).to({x:1345.75},0).wait(1).to({x:1439},0).wait(1).to({x:1544},0).wait(1));

	// size
	this.instance = new lib.size_90x90();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(14));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1566.6,90);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.btn_page13 = new lib.button();
	this.btn_page13.name = "btn_page13";
	this.btn_page13.setTransform(1858.35,1039.05,0.7084,0.4688,0,0,0,0.7,0.1);
	new cjs.ButtonHelper(this.btn_page13, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page12 = new lib.button();
	this.btn_page12.name = "btn_page12";
	this.btn_page12.setTransform(1755.05,1039.05,0.553,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page12, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page11 = new lib.button();
	this.btn_page11.name = "btn_page11";
	this.btn_page11.setTransform(1663.45,1039.05,0.5898,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page11, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page10 = new lib.button();
	this.btn_page10.name = "btn_page10";
	this.btn_page10.setTransform(1557.05,1039.05,0.7092,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page10, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1445,1039.05,0.7226,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1310.4,1039.05,0.9733,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1159.35,1039.05,0.9663,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(1007.4,1039.05,1.0327,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(829.8,1039.05,1.3889,0.4688,0,0,0,0.3,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(644.25,1039.05,1.0992,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(480.4,1039.05,1.0859,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(352.55,1039.05,0.557,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page04},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page07},{t:this.btn_page08},{t:this.btn_page09},{t:this.btn_page10},{t:this.btn_page11},{t:this.btn_page12},{t:this.btn_page13}]}).wait(1));

	// button_logo
	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(185.4,1040.05,1.9531,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_back).wait(1));

	// marker
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(316.8,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(352.45,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// pseudo
	this.instance = new lib.pseudo();
	this.instance.setTransform(0.05,-109.05,0.5252,1,0,0,0,0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// title
	this.instance_1 = new lib.title();
	this.instance_1.setTransform(324,1023.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// logo
	this.occ_logo = new lib.logo_1();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(24,1000);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background
	this.instance_2 = new lib.background();
	this.instance_2.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_3 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-2,-109,1924,1279), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, 'index');
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1922,1170);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/index_atlas_1.png", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
